<template>
  <a v-on:click="toTop"
     v-bind:class="{ visible: isVisible }">
    <img src="../assets/arrow-top-blue.svg" />
    <div>Page Top</div>
  </a>
</template>

<script>
export default {
  mounted() {
    window.addEventListener("scroll", this.hideWhenScrollYLessThan500);
  },
  destroyed() {
    window.removeEventListener("scroll", this.hideWhenScrollYLessThan500);
  },
  data: () => {
    return {
      isVisible: false
    };
  },
  methods: {
    toTop: function() {
      window.scrollTo(0, 0);
    },
    hideWhenScrollYLessThan500: function() {
      if (window.pageYOffset < 500) {
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  cursor: pointer;
  background-color: #f1d85b;
  border-radius: 8px;
  width: 47px;
  height: 47px;
  font-size: 12px;
  text-align: center;
  color: #63abcd;
  font-weight: bold;
  line-height: 1em;
  display: none;

  &.visible {
    display: block;
  }

  img {
    display: block;
    margin: 6px auto 4px;
  }
}
</style>
